export const config = {
  baseUrl: window.env.REACT_APP_BASE_URL,
  tokenUrl: window.env.REACT_APP_TOKEN_URL,
  mode: window.env.REACT_APP_MODE,
};

// export const config = {
//   baseUrl: process.env.REACT_APP_BASE_URL,
//   tokenUrl: process.env.REACT_APP_TOKEN_URL,
//   marchantCode: process.env.REACT_APP_MERCHANT_CODE,
//   payItemId: process.env.REACT_APP_PAY_ITEM_ID,
//   mode: process.env.REACT_APP_MODE,
// };



export const extractOperatorName = (url, position = "before") => {
  try {
    const parsedUrl = new URL(url);

    if (position === "before") {
      // e.g., operatorName.tvp.com
      const hostnameParts = parsedUrl.hostname.split(".");
      if (hostnameParts.length >= 3) {
        return hostnameParts[0]; // subdomain
      }
    } else if (position === "after") {
      // e.g., tvp.com/operatorName
      const pathParts = parsedUrl.pathname.split("/").filter(Boolean);
      if (pathParts.length >= 1) {
        return pathParts[0]; // first path segment
      }
    }

    return null;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};

// constants/navMode.js
export const navMode = "prod"; // or "uat"
